import PropTypes from 'prop-types';
import {useRef, useEffect} from 'react';
import Modal from '@teladoc/pulse/ui/Modal';
import notify from '@teladoc/pulse/ui/Notification';
import useTransLoader from 'i18n/use-trans-loader';
import TimeTap from '../../utils/TimeTap';
import AxleAPI from '../../utils/Axle';
import css from '../SessionDetails.scss';

const CancelModal = ({
    setShowCancelModal,
    calendarId,
    apiSessionToken,
    setSuccessfullyCancelled,
    isMobile,
    enableAxleForm,
}) => {
    const {t} = useTransLoader('confirmation');
    const isOpen = true;
    const contentRef = useRef();

    const cancelCoachingSession = async () => {
        try {
            const session =
                apiSessionToken ?? (await TimeTap.getApiSessionToken());

            enableAxleForm
                ? await AxleAPI.cancelCoachingSession(
                      apiSessionToken,
                      calendarId
                  )
                : await TimeTap.cancelCoachingSessionNonProxyCcmOnly(
                      session,
                      calendarId
                  );

            setShowCancelModal(false);

            if (isMobile) {
                setSuccessfullyCancelled(true);
            }
        } catch (error) {
            setShowCancelModal(false);

            notify({
                type: 'critical',
                title: t('cancelError'),
            });
        }
    };

    useEffect(() => {
        const timeout = setTimeout(() => {
            contentRef?.current?.focus();
        }, 100);

        return () => clearTimeout(timeout);
    }, []);

    return (
        <div>
            <Modal
                classNameRoot={css.modalTitleMobile}
                isOpen={isOpen}
                onRequestClose={setShowCancelModal}
                title={
                    <h1 ref={contentRef}>{t('cancelSessionConfirmation')}</h1>
                }
                primaryAction={{
                    variant: 'primary',
                    onClick: cancelCoachingSession,
                    children: t(`yes`),
                }}
                secondaryAction={{
                    onClick: setShowCancelModal,
                    variant: 'secondary',
                    children: t(`no`),
                }}
            />
        </div>
    );
};

CancelModal.propTypes = {
    setShowCancelModal: PropTypes.func,
    calendarId: PropTypes.number,
    apiSessionToken: PropTypes.string,
    setSuccessfullyCancelled: PropTypes.func,
    isMobile: PropTypes.bool,
    enableAxleForm: PropTypes.bool,
};

export default CancelModal;
